import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { API_ENDPOINTS } from '../config/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading, setToken, setUser } = useAuth();
  const [isProcessingToken, setIsProcessingToken] = useState(false);

  // Gérer le token Google OAuth depuis l'URL
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const userId = urlParams.get('user_id');
    
    if (token && userId && !user) {
      console.log('🔑 ProtectedRoute: Token Google OAuth détecté');
      setIsProcessingToken(true);
      
      // Stocker le token
      localStorage.setItem('access_token', token);
      setToken(token);
      
      // Nettoyer l'URL
      window.history.replaceState({}, document.title, window.location.pathname);
      
      // Récupérer les informations utilisateur
      fetch(API_ENDPOINTS.ME, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(userData => {
        setUser(userData);
        localStorage.setItem('user_data', JSON.stringify(userData));
        console.log('✅ ProtectedRoute: Utilisateur connecté via Google OAuth:', userData.email);
        setIsProcessingToken(false);
      })
      .catch(error => {
        console.error('❌ ProtectedRoute: Erreur récupération utilisateur:', error);
        setIsProcessingToken(false);
      });
    }
  }, [user, setToken, setUser]);

  if (isLoading || isProcessingToken) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="loading-spinner mx-auto mb-4"></div>
          <p className="text-gray-600">
            {isProcessingToken ? 'Traitement du token d\'authentification...' : 'Vérification de l\'authentification...'}
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;